// extracted by mini-css-extract-plugin
export default {"loading":"photography_loading__5u8oD","pcWrap":"photography_pcWrap__Jd4KZ"};